import { useContext, useEffect, useState } from 'react';
import { Button } from 'shared/components/common/Button/Button';
import { Input } from 'shared/components/common/Input/Input';
import { GlobalContext } from 'contexts/GlobalContext';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { ValidatorsTypes } from 'shared/components/common/Validator/ValidatorsTextTemplates';

import styles from './TwoFactorAuthenticationModal.module.scss';
import { useTranslation } from 'react-i18next';

function TwoFactorAuthenticationModal({ setTwoFaEnabled }) {
  const { t } = useTranslation('modals');
  const [twoFaData, setTwoFaData] = useState({
    qrcode: '',
    secret: '',
  });

  const [otpPasswords, setOtpPasswords] = useState([]);

  const {
    // closeModal,
    services: { authService },
  } = useContext(GlobalContext);

  useEffect(() => {
    (async () => {
      const response = await authService.register2fa();
      const { qrcode, secret } = response;
      setTwoFaData({
        qrcode,
        secret,
      });
    })();
  }, []);

  return (
    <div className={styles.wrapper}>
      {!otpPasswords.length ? (
        <>
          <h3>{t('2fa.title')}</h3>

          <p>{t('2fa.text')}</p>

          <a href="https://support.google.com/accounts/answer/1066447?hl=ru&co=GENIE.Platform%3DAndroid" target="_blank" rel="noreferrer">
            {t('2fa.authenticator')}
          </a>
        </>
      ) : (
        <>
          <h3>{t('2fa.passwords')}</h3>
          <p>{t('2fa.save')}</p>
          <ul>
            {otpPasswords.map((password) => {
              return <li key={password}>{password}</li>;
            })}
          </ul>
        </>
      )}

      {twoFaData.qrcode && !otpPasswords.length && (
        <>
          <img src={twoFaData.qrcode} alt="QR код" />
          <Input valueChange={() => {}} value={twoFaData.secret} disabled label={t('2fa.label')} />
          <Formik
            onSubmit={async (values) => {
              const response = await authService.enable2fa(values.secret);
              toast(t('2fa.successful'));
              window.dataLayer.push({
                event: 'event',
                eventProps: {
                  category: 'user',
                  action: 'add2fa',
                },
              });

              setTwoFaEnabled(true);
              setOtpPasswords(response.otp_passwords);
            }}
            initialValues={{
              secret: '',
            }}
            validationSchema={Yup.object().shape({
              secret: Yup.string().trim().required(ValidatorsTypes.required),
            })}
          >
            {({ errors, values, handleSubmit, setFieldValue }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <p>
                    {`${t('2fa.code')} (`}
                    {t('2fa.name')}
                    <i>Roy Team</i>
                    {'): '}
                  </p>
                  <Input
                    type="number"
                    maxLength={8}
                    label={t('2fa.input')}
                    error={errors['secret']}
                    value={values['secret']}
                    valueChange={(secret) => {
                      setFieldValue('secret', secret);
                    }}
                  />

                  <Button type="submit">{t('2fa.add')}</Button>
                </form>
              );
            }}
          </Formik>
        </>
      )}
    </div>
  );
}

export default TwoFactorAuthenticationModal;
